import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import {Translate, I18n} from 'react-redux-i18n';

import CreateBenchmarkDialog from './CreateDialog';
import PreviewBenchmarkDialog from './PreviewDialog';
import ContributeBenchmarkDialog from './ContributeDialog';
import EditBenchmarkDialog from './EditDialog';
import ThankyouDialog from '../MutualAid/ThankyouDialog';

import {
    setBenchmark as setBenchmarkAction
} from '../Exercise/ExerciseActions';

import {
  openPreviewDialog as openPreviewBenchmarkDialogAction,
  openCreateDialog as openCreateBenchmarkDialogAction,
  openEditDialog as openEditBenchmarkDialogAction,
  openCreateBenchmarkFromCopyDialog as openCreateBenchmarkFromCopyDialogAction,
  openContributeBenchmarkDialog as openContributeBenchmarkDialogAction,
  setBenchmarks as setBenchmarksAction,
  addToCurrentBenchmarks as addToCurrentBenchmarksAction,
  removeFromCurrentBenchmarks as removeFromCurrentBenchmarksAction,
} from './ExerciseBenchmarkActions';

import styles from './List.module.css';

function download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

class ExerciseBenchmarkList extends Component {
    
    constructor() {
        super();
    }
    
    componentDidMount() {
      (async ()=>{
        try {
          const response = await axios.get('/api/companies/benchmarks', {
            headers: {
                'Authorization': window.localStorage.getItem("token")
            },
            validateStatus: (status) => status < 400
          })
          this.props.setBenchmarks(response.data.benchmarks);
        } catch (err) {
          console.error(err);
        }
      })();
    }
    
    setBenchmark = (bm) => {
      const selectedBenchmark = this.props.currentBenchmarks.find((b) => b._id === bm._id);
      if(selectedBenchmark) {
        this.props.removeFromCurrentBenchmarks(bm)
      } else {
        this.props.addToCurrentBenchmarks(bm);
      }
      // this.props.setBenchmark(bm);
    }
    
    deleteBenchmark = async () => {
      const confirmation = confirm("Are you sure you want to delete this evaluation");
      if(!confirmation) return;
      try {
        await axios.delete('/api/companies/benchmarks/', {
          params: {
            id: this.props.currentBenchmarks[0]._id
          },
          headers: {
              'Authorization': window.localStorage.getItem("token")
          },
          validateStatus: (status) => status < 400
        })
        this.props.setBenchmarks(this.props.benchmarks.filter((benchmark) => benchmark._id !== this.props.currentBenchmarks[0]._id));
        this.props.removeFromCurrentBenchmarks(this.props.currentBenchmarks[0]);
        this.props.setBenchmark(null);
      } catch (err) {
        console.error(err);
      }
    }
    
    importEvaluation = async (event) => {
      try {
        const file = event.target.files[0];
        // console.log("FILE:", file);
        const data = new FormData();
        data.append('importFile', file);
        const response = await axios.post('/api/companies/benchmarks/import', data,{
          headers: {
              'Authorization': window.localStorage.getItem("token")
          }
        })
        if(response.status !== 201) {
          console.error(response.status, response.data);
          return alert("Failed to import evaluations");
        }
        this.props.setBenchmarks(this.props.benchmarks.concat(response.data.benchmarks));
        return alert("Import evaluations succeeded");
      } catch (err) {
        console.error(err);
        return alert("Importing evaluations failed");
      }
    }
    
    render() {
      
      const descriptionOption = this.props.descriptionOption || "exercise.BenchmarkJoinDescription";
      
      return (
        <React.Fragment>
          <CreateBenchmarkDialog />
          <EditBenchmarkDialog />
          <PreviewBenchmarkDialog />
          <ContributeBenchmarkDialog />
          <ThankyouDialog />
          <div className="col-md-12 mt-4" style={{display: (this.props.curUser?.company?.hideBenchmarks || process.env.REACT_APP_HIDE_BENCHMARKS)? 'none' : 'block'}}>
            <input type="file" style={{display: 'none'}} id="benchmark-file-uploader" accept=".json" onChange={this.importEvaluation} />
            <div className="column">
              <div>
                <h4><i className="fas fa-users" /><Translate value="exercise.Benchmarks"/></h4>
              </div>
              <div>
                <h6><Translate value={descriptionOption} /></h6>
              </div>
              {
                !this.props.showPreviewButtonOnly &&
                <div className={`${styles.horizontalButtons}`}>
                  <button
                    className="btn btn-primary"
                    onClick={()=>{
                        this.props.openCreateBenchmarkDialog()
                      }
                    }
                  >
                    <i className={"fas fa-fw fa-plus"}/>
                    <Translate value="controls.Create" />
                  </button>
                  <button
                    className="btn btn-primary"
                    disabled={this.props.currentBenchmarks.length !== 1}
                    onClick={()=>{
                        this.props.openCreateBenchmarkFromCopyDialog()
                      }
                    }
                  >
                    <i className={"fas fa-fw fa-plus"}/>
                    <Translate value="controls.CreateFrom" />
                  </button>
                </div>
              }
              <div className="row col-sm-12" style={{marginTop: 30}}>
                <div className="row col-sm-6">
                  <div className="column" style={{maxHeight: '96%', overflowY: 'scroll', width: '100%'}}>
                  {
                    this.props.benchmarks.sort((a, b) => (a.name === b.name? 0 : (a.name < b.name ? -1 : 1))).map((bm) => 
                      <div key={"bm-"+bm._id}>
                        <input type="checkbox" className="form-check-input" checked={!!this.props.currentBenchmarks.find((b) => b._id === bm._id)} onChange={(e)=>this.setBenchmark(bm)} />
                        <span style={{marginLeft: 3}}>{bm.name}</span>
                      </div>
                    )
                  }
                  </div>
                </div>
                {
                  this.props.benchmarks.length !== 0
                  &&
                  <div className={`column col-sm-6 wrap ${styles.verticalButtons}`}>
                    <div className="row" style={{marginLeft: 0, marginBottom: 5}}>
                      <ul className="nav nav-tabs">
                        <li className="nav-item active">
                            <a href="#general" className="nav-link active" data-bs-toggle="tab">General</a>
                        </li>
                        <li className="nav-item">
                            <a href="#import-export" className="nav-link" data-bs-toggle="tab">Import/Export</a>
                        </li>
                      </ul>
                    </div>
                    
                    <div className="tab-content">
                      <div className="tab-pane active" id="general">
                        <div className="column">
                          <button
                            className="btn btn-primary"
                            style={{marginBottom: 5}}
                            onClick={this.props.openPreviewBenchmarkDialog}
                            disabled={this.props.currentBenchmarks.length === 0}
                          >
                            <i className="fas fa-fw fa-eye" />
                            <Translate value="controls.Preview" />
                          </button>
                          {
                            !this.props.showPreviewButtonOnly &&
                            <React.Fragment>
                              <button
                                className="btn btn-primary"
                                style={{marginBottom: 5}}
                                disabled={this.props.currentBenchmarks.length !== 1}
                                onClick={()=>{
                                    this.props.openEditBenchmarkDialog()
                                  }
                                }
                              >
                                <i className={"fas fa-fw fa-edit"}/>
                                <Translate value="controls.Edit" />
                              </button>
                              <button
                                className="btn btn-danger"
                                style={{marginBottom: 5}}
                                disabled={this.props.currentBenchmarks.length !== 1}
                                onClick={()=>{
                                    this.deleteBenchmark()
                                  }
                                }
                              >
                                <i className={"fas fa-fw fa-trash"}/>
                                <Translate value="controls.Delete" />
                              </button>
                              <button
                                className="btn btn-primary"
                                style={{marginBottom: 5}}
                                disabled={this.props.currentBenchmarks.length !== 1}
                                onClick={()=>{
                                    this.props.openContributeBenchmarkDialog()
                                  }
                                }
                              >
                                <i className={"fas fa-fw fa-share-alt"}/>
                                <Translate value="controls.ContributeToMutualAid" />
                              </button>
                            </React.Fragment>
                          }
                        </div>
                      </div>
                      <div className="tab-pane" id="import-export">
                        <div className="column">
                          <button
                            className="btn btn-primary"
                            style={{marginBottom: 5}}
                            onClick={()=>{
                                document.getElementById("benchmark-file-uploader").click();
                              }
                            }
                          >
                            <i className={"fas fa-fw fa-plus"}/>
                            <Translate value="exercise.ImportBenchmark" />
                          </button>
                          <button
                            className="btn btn-primary"
                            style={{marginBottom: 5}}
                            disabled={this.props.currentBenchmarks.length === 0}
                            onClick={()=>{
                                download("evaluations.json", JSON.stringify(this.props.currentBenchmarks));
                              }
                            }
                          >
                            <i className={"fas fa-fw fa-plus"}/>
                            <Translate value="exercise.ExportBenchmark" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </React.Fragment>
      )
    }
}

const mapStateToProps = (state)=>({
    curUser: state.login.userData,
    benchmark: state.exercise.benchmark,
    benchmarks: state.exerciseBenchmark.benchmarks,
    currentBenchmarks: state.exerciseBenchmark.currentBenchmarks
});

const mapDispatchToProps = {
    setBenchmark: setBenchmarkAction,
    setBenchmarks: setBenchmarksAction,
    openPreviewBenchmarkDialog: openPreviewBenchmarkDialogAction,
    openCreateBenchmarkDialog: openCreateBenchmarkDialogAction,
    openCreateBenchmarkFromCopyDialog: openCreateBenchmarkFromCopyDialogAction,
    openContributeBenchmarkDialog: openContributeBenchmarkDialogAction,
    openEditBenchmarkDialog: openEditBenchmarkDialogAction,
    addToCurrentBenchmarks: addToCurrentBenchmarksAction,
    removeFromCurrentBenchmarks: removeFromCurrentBenchmarksAction
}

export default connect(mapStateToProps, mapDispatchToProps)(ExerciseBenchmarkList);